<template>
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.92605 0.814941C2.20783 0.814941 0.814941 2.20783 0.814941 3.92605C0.814941 5.64427 2.20783 7.03716 3.92605 7.03716C5.42769 7.03716 6.68084 5.9733 6.97291 4.55816C7.03962 4.58057 7.11105 4.59272 7.18531 4.59272H14.5186C14.8868 4.59272 15.1853 4.29424 15.1853 3.92605C15.1853 3.55786 14.8868 3.25939 14.5186 3.25939H7.18531C7.11105 3.25939 7.03962 3.27153 6.97291 3.29394C6.68084 1.87881 5.42769 0.814941 3.92605 0.814941ZM2.14827 3.92605C2.14827 2.94421 2.94421 2.14827 3.92605 2.14827C4.90789 2.14827 5.70383 2.94421 5.70383 3.92605C5.70383 4.90789 4.90789 5.70383 3.92605 5.70383C2.94421 5.70383 2.14827 4.90789 2.14827 3.92605Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.29642 11.4075C1.92823 11.4075 1.62976 11.706 1.62976 12.0742C1.62976 12.4424 1.92823 12.7409 2.29642 12.7409H9.03469C9.33987 14.1387 10.5848 15.1853 12.0742 15.1853C13.7924 15.1853 15.1853 13.7924 15.1853 12.0742C15.1853 10.356 13.7924 8.96309 12.0742 8.96309C10.5848 8.96309 9.33987 10.0097 9.03469 11.4075H2.29642ZM12.0742 13.852C11.0924 13.852 10.2964 13.056 10.2964 12.0742C10.2964 11.0924 11.0924 10.2964 12.0742 10.2964C13.056 10.2964 13.852 11.0924 13.852 12.0742C13.852 13.056 13.056 13.852 12.0742 13.852Z"
    />
  </svg>
</template>
